import { TeacherUsersUIProvider } from "./TeacherUsersUIContext";
import { TeacherUsersCard } from "./TeacherUsersCard";

export function TeacherUsersPage() {
  return (
    <TeacherUsersUIProvider>
      <TeacherUsersCard />
    </TeacherUsersUIProvider>
 );
}